const flutterHealth = {
  en: {
    flutterHealth: {
      title: 'Health',
      description: 'Medical assistance',
      instructions: 'Instructions',
      'instructions.description': 'Procedure for obtaining insurance aid',
      'instructions.kz': 'Phone calls within Kazakhstan is free of charge',
      'instructions.world': 'For International Calls',
      'instructions.whatsapp': 'Write to WhatsApp',
      'instructions.title': 'Instructions Health Insurance',
      'acc1.title': 'Client Actions',
      'acc1.text1':
        '1. Please contact the call centre of the medical service company whose contacts are on the back cover of the health insurance card to inform them of the necessity to apply for medical services.',
      'acc1.text2':
        '2. In case of emergency, if the health condition does not allow for the call and the services were provided by the ambulance service within 24 hours from the moment when the insured event occurred, please notify the service company.',
      'acc2.title':
        'An insured client shall have the right to contact directly to the following authorities:',
      'acc2.text1': '1. A service company (Assistance);',
      'acc2.text2': '2. Emergency medical assistance;',
      'acc2.text3': '3. Family doctor;',
      'acc2.text4': '4. Dentistry (from the Assistance network)',
      'acc3.title': 'List of documents',
      'acc3.text1': '1. Identity card; ',
      'acc3.text2':
        '2. Plastic medical card - identifying the insured person; ',
      'acc3.text3':
        '3. Referral by a Physician - employee of a health care providing company; ',
      'acc3.text4': 'for outpatient polyclinic care: ',
      'acc3.text5': '1. invoice; ',
      'acc3.text6': '2. a fiscal receipt; ',
      'acc3.text7':
        '3. copy of an outpatient card with the results of the examination and the diagnosis. ',
      'acc3.text8': 'for inpatient care: ',
      'acc3.text9': '1. invoice; ',
      'acc3.text10': '2. fiscal receipt; ',
      'acc3.text11': '3. copy of the hospital discharge;',
      'acc3.text12': '4. calculation list. ',
      'acc3.text13': 'for dental treatment:',
      'acc3.text14': '1. purchase order (document issued by the dentist);',
      'acc3.text15': '2. receipt. ',
      'acc3.text16': 'For pharmaceuticals:',
      'acc3.text17': '1. sales receipt;',
      'acc3.text18': '2. fiscal receipt;',
      'acc3.text19':
        "3. a copy of the doctor's prescription with the diagnosis and recommendations. ",
      'acc3.text20':
        'More detailed information on the list of documents to be submitted can be obtained from the specialists of the Health Insurance Board',
    },
  },
  kz: {
    flutterHealth: {
      title: 'Денсаулық',
      description: 'Медициналық көмек',
      instructions: 'Нұсқаулықтар',
      'instructions.description':
        'Сіздің сақтандыру көмегін алу үшін  әрекет ету тәртібіңіз',
      'instructions.kz': 'Қазақстан бойынша қоңырау шалу тегін',
      'instructions.world': 'Халықаралық қоңыраулар үшін',
      'instructions.whatsapp': 'WhatsApp-ға жазу',
      'instructions.title': 'Медициналық сақтандыру нұсқаулығы',
      'acc1.title': 'Клиенттің әрекеттері',
      'acc1.text1':
        '1. Байланыстары медициналық сақтандыру карточкасының артқы жағында көрсетілген медициналық сервистік компанияның call орталығына жүгіну, медициналық қызметтерді алу қажеттілігі туралы хабарлау;',
      'acc1.text2':
        '2. Төтенше жағдайда, денсаулық жағдайына байланысты өтініш жасау мүмкін болмаған кезде және қызметтерді жедел жәрдем қызметі сақтандыру жағдайы басталған сәттен бастап 24 сағат ішінде сервистік компанияға хабарлау.',
      'acc2.title': 'Сақтандырылған клиент тікелей жүгінуге құқылы:',
      'acc2.text1': '1. Сервистік компанияға (Ассистанс);',
      'acc2.text2': '2. Жедел медициналық көмекке;',
      'acc2.text3': '3. Отбасылық дәрігерге;',
      'acc2.text4': '4. Стоматологияға (Ассистанс желісінен)',
      'acc3.title': 'Құжаттар тізімі',
      'acc3.text1': '1. Жеке куәлік;',
      'acc3.text2':
        '2. Сақтандырылушыны анықтайтын пластикалық медициналық карта;',
      'acc3.text3':
        '3. Медициналық сервистік компанияның дәрігер-қызметкерінің жолдамасы;',
      'acc3.text4': 'амбулаториялық-емханалық көмек бойынша:',
      'acc3.text5': '1. шот-фактура;',
      'acc3.text6': '2. қазыналық чек;',
      'acc3.text7':
        '3. тексеру нәтижелері, диагнозы көрсетілген амбулаториялық картаның көшірмесі.',
      'acc3.text8': 'стационарлық емдеу бойынша:',
      'acc3.text9': '1. шот-фактура;',
      'acc3.text10': '2. қазыналық чек;',
      'acc3.text11': '3. стационардан үзінді көшірме;',
      'acc3.text12': '4. калькуляция парағы.',
      'acc3.text13': 'стоматологиялық емдеу бойынша:',
      'acc3.text14': '1. тапсырыс-наряд (тіс дәрігері беретін құжат);',
      'acc3.text15': '2. фискалдық чек.',
      'acc3.text16': 'Дәрі-дәрмекпен қамтамасыз ету бойынша:',
      'acc3.text17': '1. тауар чегі;',
      'acc3.text18': '2. қазыналық чек;',
      'acc3.text19':
        '3. алынған ұсынымдардың диагнозы көрсетілген дәрігер тағайындауының көшірмесі.',
      'acc3.text20':
        'Ұсынылатын құжаттар тізімі бойынша толық ақпаратты Медициналық сақтандыру департаментінің мамандарынан нақтылауға болады',
    },
  },
  ru: {
    flutterHealth: {
      title: 'Здоровье',
      description: 'Медицинская помощь',
      instructions: 'Инструкции',
      'instructions.description':
        'Ваш порядок действий для получения страховой помощи',
      'instructions.kz': 'Звонок по Казахстану бесплатный',
      'instructions.world': 'Для международных звонков',
      'instructions.whatsapp': 'Написать в WhatsApp',
      'instructions.title': 'Инструкция Медицинское страхование',
      'acc1.title': 'Действия клиента',
      'acc1.text1':
        '1. Обратиться в call центр медицинской сервисной компании, контакты которой указаны на обратной стороне карточки медицинского страхования, сообщить о необходимости получения медицинских услуг;',
      'acc1.text2':
        '2. В экстренном случае, когда по состоянию здоровья обращение не возможно и услуги были оказаны   службой скорой   помощи в течение 24 часов с момента, когда наступил страховой случай известить сервисную компанию.',
      'acc2.title': 'Застрахованный клиент имеет право напрямую обратиться в:',
      'acc2.text1': '1. Сервисную компанию (Ассистанс);',
      'acc2.text2': '2. Скорую медицинскую помощь;',
      'acc2.text3': '3. Семейному врачу;',
      'acc2.text4': '4. Стоматологию (из сети Ассистанса)',
      'acc3.title': 'Список документов',
      'acc3.text1': '1. Удостоверение личности; ',
      'acc3.text2':
        '2. Пластиковая медицинская карточка – идентифицирующая застрахованного; ',
      'acc3.text3':
        '3. Направление врача – работника медицинской сервисной компании; ',
      'acc3.text4': 'по амбулаторно-поликнической помощи: ',
      'acc3.text5': '1. счет-фактуру; ',
      'acc3.text6': '2. фискальный чек; ',
      'acc3.text7':
        '3. копия амбулаторной карты с результатами обследования, указанием диагноза.',
      'acc3.text8': 'по стационарному лечению: ',
      'acc3.text9': '1. счет-фактуру; ',
      'acc3.text10': '2. фискальный чек; ',
      'acc3.text11': '3. копию выписки из стационара; ',
      'acc3.text12': '4. калькуляционный лист. ',
      'acc3.text13': 'по стоматологическому лечению:',
      'acc3.text14':
        '1. заказ-наряд (документ выдаваемый врачом стоматологом);',
      'acc3.text15': '2. фискальный чек. ',
      'acc3.text16': 'По лекарственному обеспечению:',
      'acc3.text17': '1. товарный чек;',
      'acc3.text18': '2. фискальный чек;',
      'acc3.text19':
        '3. копию назначения врача с указанием диагноза полученных рекомендаций. ',
      'acc3.text20':
        'Более полную информацию по перечню предоставляемых документов Вы можете уточнить у специалистов Департамента медицинского страхования',
    },
  },
};

export default flutterHealth;
